class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (typeof window.autoplayingSwiper === 'object' && window.autoplayingSwiper.autoplay && typeof window.autoplayingSwiper.autoplay.stop === 'function') {
      window.autoplayingSwiper.autoplay.stop();
    }
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("active");
    })
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    requestIdleCallback(() => {
      // Smartbuy state handling on cart drawer opening
      if (isSmartbuyEligible()) {
        enableSmartbuyOnItems();
      } else {
        removeSmartbuyIfNeeded();
      }
      // Toggle gift voucher visibility based on Smartbuy cookie
      const giftVoucherInput = document.querySelector("#CartDrawer-Form .cart__gift-voucher");
      if (giftVoucherInput) {
        giftVoucherInput.style.display = getCookieVal("utmsource_smartbuy") != null ? "none" : "block";
      }
      document.querySelectorAll("#CartDrawer .jw-cart-wallet-credits").forEach((element) => {
        element.style.display = getCookieVal("utmsource_smartbuy") != null ? "none" : "";
      });
      if(typeof checkoutEvents === 'function') checkoutEvents();
    });

    this.addEventListener("transitionend", () => {
      const containerToTrapFocusOn = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
      const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(containerToTrapFocusOn, focusElement);
    },{ once: true });

    // Initialize wallet credits balance when the cart drawer is opened
    if (typeof initWalletCreditsBalance === "function") {
      Promise.resolve(initWalletCreditsBalance()).then(() => {
        if (typeof cancelSmartbuyRedeemedWalletCredits === "function") {
          cancelSmartbuyRedeemedWalletCredits();
        }
      });
    }

    closeATBModalonCartOpen();
    setTimeout(() => {
      document.body.classList.add("overflow-hidden");
    })
  }

  close() {
    this.classList.remove("active");
    if (typeof window.autoplayingSwiper === 'object' && window.autoplayingSwiper.autoplay && typeof window.autoplayingSwiper.autoplay.stop === 'function') {
      window.autoplayingSwiper.autoplay.start();
    }
    removeTrapFocus(this.activeElement, false);
    setTimeout(() => {
      document.body.classList.toggle("overflow-hidden");
    })
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
     if (typeof window.jwHandleCartDrawerRender === "function") {
      window.jwHandleCartDrawerRender();
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
